//印度语
export default {
	login: {
		salesBackend: "OMELINK सेल्स बैकेंड लॉगिन",
		account: "खाता",
		password: "पासवर्ड",
		login: "लॉग इन",
		pleaseEnter: "कृपया दर्ज करें",
		userName: "उपयोगकर्ता नाम",
		loginSuccessful: "लॉगिन सफल",
		usingOa: "अपने OA खाते का उपयोग करके लॉग इन करें",
		usingSjfood: "अपने HiFood खाते का उपयोग करके लॉग इन करें",
	},
	index: {
		customerSettings: "ग्राहक सेटिंग्स",
		personalInformation: "व्यक्तिगत जानकारी",
		logOut: "लॉग आउट",
		selectLanguage: "भाषा चुनें",
		confirmExit: "बाहर निकलने की पुष्टि करें?",
		hint: "संकेत",
		productSettings: "उत्पाद सेटिंग्स",
		syncSettings: "सिंक सेटिंग्स",
		customerBinding: "ग्राहक बाइंडिंग",
	},
	personal: {
		avatar: "अवतार",
		nickName: "उपनाम",
	},
	operator: {
		addTo: "जोड़ें",
		authorizer: "अधिकृतकर्ता",
		permissions: "अनुमतियाँ",
		startingTime: "प्रारंभ समय",
		endTime: "समाप्ति समय",
		revise: "संशोधित करें",
		delete: "हटाएं",
		viewPermissions: "अनुमतियाँ देखें, भेजने की अनुमतियाँ",
	},
	customer: {
		customerCode: "ग्राहक कोड",
		customerName: "ग्राहक का नाम",
		warehouse: "गोदाम",
		customerBindingQuantity: "ग्राहक बाइंडिंग मात्रा",
		maintenanceQuantity: "सामग्री परिवर्तन रखरखाव मात्रा",
		operate: "संचालित करें",
		customerBinding: "ग्राहक बाइंडिंग",
		productSettings: "उत्पाद सेटिंग्स",
		batchOpertion: "बैच रखरखाव",
		selectCustomer: "ग्राहक चुनें",
		importItem: "आइटम आयात करें",
		batchImportItem: "बैच आइटम आयात करें",
		successfully: "पूर्ण",
		previousStep: "पिछला चरण",
		nextStep: "अगला चरण",
		selectFile: "फ़ाइल चुनें",
		templateDownload: "टेम्पलेट डाउनलोड",
		noFileSelected: "कोई फ़ाइल नहीं चुनी गई",
		downloadingTemplate: "टेम्पलेट सफलतापूर्वक डाउनलोड किया गया",
		operationSuccess: "बैच रखरखाव सफल",
		aTotalOf: "कुल",
		errorTips: "आइटमों में सिस्टम द्वारा ID त्रुटियाँ पाई गईं, आयात विफल! कृपया जाँच करके पुनः प्रयास करें।",
		importSuccessfully: "आयात सफल",
	},
	customerProduct: {
		myClient: "मेरा ग्राहक",
		productSettings: "उत्पाद सेटिंग्स",
		specification: "विशिष्टता",
		editedSuccessfully: "सफलतापूर्वक संपादित!",
	},
	customerProductLastest: {
		myClient: "मेरा ग्राहक",
		productSettings: "उत्पाद सेटिंग्स",
		syncSettings: "सिंक सेटिंग्स",
		changeUpdates: "उत्पाद परिवर्तन अपडेट जांचें",
		old: "पुराना",
		new: "नया",
		state: "स्थिति",
		waitingForConfirmation: "पुष्टि की प्रतीक्षा",
		applied: "लागू किया गया",
		notApplied: "लागू नहीं किया गया",
		operate: "संचालित करें",
		newAdditions: "नए जोड़",
		renew: "नवीनीकृत करें",
		time: "समय",
		SALESConfirmed: "SALES द्वारा पुष्टि",
		application: "आवेदन",
		successfulOperation: "सफल संचालन!",
	},
	customerPhone: {
		myClient: "मेरा ग्राहक",
		customerBinding: "ग्राहक बाइंडिंग",
		addBinding: "बाइंडिंग जोड़ें",
		noData: "कोई डेटा नहीं, कृपया जोड़ें",
		telephoneNumber: "टेलीफोन नंबर",
		remarkName: "टिप्पणी नाम",
		memorandum: "ज्ञापन",
		smsDisable: "एसएमएस अक्षम",
		operate: "संचालित करें",
		edit: "संपादित करें",
		unbind: "अनबाइंड",
		CRMContact: "CRM संपर्क चुनें",
		enterANote: "एक नोट दर्ज करें",
		editBinding: "बाइंडिंग संपादित करें",
		correctPhoneNumber: "कृपया टेलीफोन नंबर का सही प्रारूप दर्ज करें",
		ContentIsTooLong: "कृपया ज्ञापन दर्ज करें",
		bindingSuccessfully: "बाइंडिंग सफलतापूर्वक जोड़ी गई!",
		errorMessage: "भरी गई जानकारी में त्रुटियाँ हैं!",
		successfulOperation: "सफल संचालन!",
		setupSuccessful: "सेटअप सफल!",
		closedSuccessfully: "सफलतापूर्वक बंद!",
		unbindHint: "क्या आप अनबाइंड करना चाहते हैं?",
		hint: "संकेत",
		UnbindingSuccessful: "अनबाइंडिंग सफल!",
		numberIdentityNote: "नंबर, पहचान, नोट",
		selectIdentityNote: "पहचान नोट चुनें",
		customRemarks: "कस्टम नंबर पहचान नोट",
		pleaseEnterCustomRemarks: "कृपया कस्टम नंबर पहचान नोट दर्ज करें",
		manager: "प्रबंधक",
		boss: "मालिक",
		headChef: "हेड शेफ",
		accountant: "लेखाकार",
		custom: "कस्टम",
		phoneEditDelateGuid: "CRM से प्राप्त संपर्कों पर संचालन नहीं किया जा सकता। कृपया CRM में संचालन करें।",
		billManagement: "होकारी अपना",
		add: "नया",
	},
	productSpecification: {
		addTo: "जोड़ें",
		nameSearch: "खोज के लिए विशिष्टता नाम दर्ज करें",
		specificationName: "विशिष्टता नाम",
		operate: "संचालित करें",
		edit: "संपादित करें",
		editSpecifications: "विशिष्टता संपादित करें",
		attributes: "विशेषताएँ",
		addAttributes: "कृपया विशेषताएँ जोड़ें",
		name: "नाम",
		optionName: "विकल्प नाम दर्ज करें",
		enterSpecificationName: "कृपया विशिष्टता नाम दर्ज करें!",
		addOptions: "कृपया विकल्प जोड़ें!",
		editedSuccessfully: "सफलतापूर्वक संपादित!",
		errorMessage: "भरी गई जानकारी में त्रुटियाँ हैं!",
		enterAttributeName: "विशेषता नाम दर्ज करें",
		sureDelete: "क्या आप हटाना चाहते हैं?",
		hint: "संकेत",
		successfullyDeleted: "सफलतापूर्वक हटाया गया!",
		cannotSortWhenSearching: "खोज के दौरान सॉर्ट नहीं किया जा सकता",
		sortingSaveFail: "सॉर्टिंग सेव फेल",
		sortingSaveSuccess: "सॉर्टिंग सेव सक्सेस",
	},
	productHistory: {
		materialChange: "सामग्री परिवर्तन रखरखाव",
		aliasSearch: "खोज के लिए उत्पाद नाम या उपनाम दर्ज करें",
		noData: "कोई डेटा नहीं",
		productName: "उत्पाद नाम",
		productAlias: "उत्पाद उपनाम",
		category: "श्रेणी",
		state: "स्थिति",
		enable: "सक्षम",
		disable: "अक्षम",
		operate: "संचालित करें",
		edit: "संपादित करें",
		codingImportGoods: "ग्राहक कोड द्वारा उत्पाद आयात करें",
		importProducts: "उत्पाद आयात करें",
		enterCustomerCode: "ग्राहक कोड दर्ज करें",
		selectProduct: "उत्पाद चुनें",
		finish: "समाप्त",
		customerCode: "ग्राहक कोड",
		nextStep: "अगला चरण",
		cancelSelection: "चयन रद्द करें",
		previous: "पिछला",
		import: "आयात",
		aTotalOf: "कुल ",
		productImportSuccess: "उत्पाद सफलतापूर्वक आयात किए गए",
		productImportFailure: "उत्पाद सिस्टम द्वारा डुप्लिकेट के रूप में पाए गए और आयात विफल! कृपया आयात से पहले जांचें।",
		pleaseEnterCustomerCode: "कृपया ग्राहक कोड दर्ज करें!",
		messageInformationCorrectly: "कृपया जानकारी सही ढंग से भरें!",
		pleaseSelectProduct: "कृपया वह उत्पाद जानकारी चुनें जिसे आप आयात करना चाहते हैं!",
	},
	productEdit: {
		editProductInformation: "उत्पाद जानकारी संपादित करें",
		basicInformation: "मूल जानकारी",
		productName: "उत्पाद नाम",
		productAlias: "उत्पाद उपनाम",
		category: "श्रेणी",
		state: "स्थिति",
		enable: "सक्षम",
		disable: "अक्षम",
		specificationInformation: "विशिष्टता जानकारी",
		selectSpecifications: "विशिष्टताएँ चुनें",
		deleteSpecification: "विशिष्टता हटाएं",
		enterSpecificationName: "विशिष्टता नाम दर्ज करें",
		addSpecs: "विशिष्टताएँ जोड़ें",
		pleaseChoose: "कृपया चुनें",
		attributes: "विशेषताएँ",
	},
	productAll: {
		aliasSearch: "खोज के लिए उत्पाद नाम या उपनाम दर्ज करें",
		noData: "कोई डेटा नहीं",
		productName: "उत्पाद नाम",
		productAlias: "उत्पाद उपनाम",
		category: "श्रेणी",
		state: "स्थिति",
		enable: "सक्षम",
		disable: "अक्षम",
		operate: "संचालित करें",
		edit: "संपादित करें",
		insert: "डालें",
		insertingSuccessfully: "इतिहास सफलतापूर्वक डाला गया!",
	},
	avatar: {
		setAvatar: "अवतार सेट करें",
		preview: "पूर्वावलोकन",
		changePicture: "चित्र बदलें",
		enlarge: "बड़ा करें",
		zoomOut: "छोटा करें",
		rotateLeft: "बाईं ओर घुमाएँ",
		rotateRight: "दाईं ओर घुमाएँ",
		upload: "अपलोड",
		errorGetAvatar: "अवतार प्राप्त करने में विफल, कृपया बाद में पुनः प्रयास करें",
		sizeCannotExceed: "अपलोड किए गए अवतार चित्र का आकार 2MB से अधिक नहीं हो सकता!",
		selectPicture: "चित्र चुनें",
		setupSuccessful: "सेटअप सफल",
		uploadFailed: "अपलोड विफल, कृपया बाद में पुनः प्रयास करें",
	},
	addSpecification: {
		addSpecs: "विशिष्टताएँ जोड़ें",
		specificationName: "विशिष्टता नाम",
		attributes: "विशेषताएँ",
		addAttributes: "कृपया विशेषताएँ जोड़ें",
		addTo: "जोड़ें",
		name: "नाम",
		operate: "संचालित करें",
		delete: "हटाएं",
		addProperties: "गुण जोड़ें",
		enterAttributeName: "विशेषता नाम दर्ज करें",
		enterSpecificationName: "विशिष्टता नाम दर्ज करें!",
		addOptions: "विकल्प जोड़ें",
		addedSuccessfully: "सफलतापूर्वक जोड़ा गया!",
		errorMessage: "भरी गई जानकारी में त्रुटियाँ हैं!",
	},
	chatEmojiPicker: {
		recent: "हाल ही का",
		people: "लोग",
		nature: "प्रकृति",
		foods: "भोजन",
		activity: "गतिविधि",
		places: "स्थान",
		objects: "वस्तुएँ",
		symbols: "प्रतीक",
		flags: "झंडे",
	},
	chatHistoryMessage: {
		viewContext: "संदर्भ देखें",
		copy: "कॉपी",
		save: "सहेजें",
		copiedToClipboard: "क्लिपबोर्ड पर कॉपी किया गया",
		copyFailed: "कॉपी विफल",
		errorTextMessage: "अभी केवल पाठ संदेश कॉपी का समर्थन करता है",
		errorMessage: "अभी केवल वॉइस संदेश सहेजने का समर्थन करता है",
	},
	chatHistory: {
		enterChatContent: "चैट सामग्री दर्ज करें",
		back: "पीछे",
	},
	chatMessageCheckDetails: {
		serialNumber: "क्रमांक",
		amount: "राशि",
		uploadDate: "अपलोड तिथि",
		frontPicture: "चेक का सामने का चित्र",
		reversePicture: "चेक का पीछे का चित्र",
		supplier: "आपूर्तिकर्ता",
		userAmount: "उपयोगकर्ता इनपुट राशि",
		checkStatus: "चेक स्थिति",
	},
	chatMessageCheck: {
		checkUploadReminder: "चेक अपलोड अनुस्मारक",
		checkCheckUpload: "चेक अपलोड जांचें",
		checkDetails: "चेक विवरण",
	},
	chatMessageNonsupport: {
		versionIsTooLow: "आपका संस्करण बहुत पुराना है, इस सामग्री को देखने के लिए",
	},
	chatMessageOrder: {
		orderDetails: "ऑर्डर विवरण",
		order: "आर्डर",
		deliveryDate: "डिलीवरी की तारीख",
		productsOrdered: "आर्डर किए गए उत्पाद",
		productsInclude: "उत्पादों में शामिल हैं",
		viewOrder: "आर्डर देखें",
	},
	chatMessageReplenishment: {
		title: "स्मार्ट रीप्लेनिशमेंट",
		deliveryDate: "डिलीवरी की तारीख",
		items: "ITEM संख्या",
		confirming: "पुष्टि लंबित",
		expired: "समाप्त",
		confirmed: "{name} द्वारा पुष्ट",
	},
	chatMessageReadStatus: {
		haveRead: "पढ़ लिया",
		unread: "अपठित",
		readingStatus: "पठन स्थिति",
	},
	chatMessageStatus: {
		resendThisMessage: "क्या इस संदेश को फिर से भेजना है?",
		hint: "संकेत",
	},
	chatMessageText: {
		translateText: "पाठ अनुवाद करें",
	},
	chatMessageVoice: {
		voiceIsCorrupted: "वॉइस भ्रष्ट है",
	},
	chatMessages: {
		retractedMessage: "आपने एक संदेश वापस ले लिया",
		copy: "कॉपी",
		save: "सहेजें",
		recall: "याद करें",
		concealTranslated: "अनूदित छिपाएं",
		translated: "अनूदित",
		copiedToClipboard: "क्लिपबोर्ड पर कॉपी किया गया",
		copyFailed: "कॉपी विफल",
		supportsTextMessages: "अभी केवल पाठ संदेश कॉपी का समर्थन करता है",
		supportsTextVoice: "अभी केवल वॉइस संदेश सहेजने का समर्थन करता है",
		supportsTexttranslated: "अभी केवल पाठ अनुवाद का समर्थन करता है",
	},
	chatPicturePaster: {
		sendThisImage: "क्या इस छवि को भेजना है?",
		send: "भेजें",
	},
	chatRecorder: {
		recording: "रिकॉर्डिंग",
		stop: "रोकें",
		send: "भेजें",
		recordingFailed: "रिकॉर्डिंग विफल",
		timeShort: "बोलने का समय बहुत कम है",
		timeLong: "बोलने का समय बहुत लंबा है",
		microphonePermissionDenied: "रिकॉर्डिंग विफल रही, कृपया माइक्रोफोन तक पहुँचने की अनुमति दें।",
	},
	contactList: {
		remarkName: "टिप्पणी नाम:",
	},
	contacts: {
		contactPerson: "संपर्क व्यक्ति",
	},
	conversationList: {
		recentChat: "हाल की चैट",
		remarkName: "टिप्पणी नाम:",
		cancelStick: "स्टिक रद्द करें",
		haveRead: "पढ़ लिया",
		unread: "अपठित",
		stick: "स्टिक",
		pinnedSuccessfully: "सफलतापूर्वक पिन किया गया!",
		unpinnedSuccessfully: "सफलतापूर्वक अनपिन किया गया!",
	},
	detailContact: {
		chatInformation: "चैट जानकारी",
		METISusageCount: "METIS उपयोग गणना:",
		leftOver: "बचा हुआ",
		strip: "पट्टी",
		nickName: "उपनाम",
		remarkName: "टिप्पणी नाम",
		revise: "संशोधित करें",
		associatedCustomers: "संबद्ध ग्राहक",
		none: "कोई नहीं",
		smartResponse: "METIS स्मार्ट प्रतिक्रिया ग्राहक सेवा",
		open: "खोलें",
		close: "बंद करें",
		automaticTranslation: "स्वचालित अनुवाद",
		setupSuccessful: "सेटअप सफल!",
		enterRemarks: "टिप्पणियाँ दर्ज करें",
		hint: "संकेत",
		yes: "हाँ",
		no: "नहीं",
		phoneNumber: "फ़ोन नंबर",
		openTip1: "PST 13:30 - अगले दिन PST 01:00",
		openTip2: "इस अवधि के दौरान, यदि ग्राहक के प्रश्न का उद्देश्य एक ज्ञात समस्या के रूप में पहचाना जाता है, तो METIS सामान्य रूप से प्रतिक्रिया देगा।",
		openTip3: "इस अवधि के दौरान, यदि ग्राहक के प्रश्न का उद्देश्य अज्ञात समस्या के रूप में पहचाना जाता है, तो METIS प्रतिक्रिया नहीं देगा।",
		userDoesNotBelong: "वर्तमान उपयोगकर्ता आपका संपर्क नहीं है",
	},
	detailGroup: {
		groupInformation: "समूह जानकारी",
		groupChatName: "समूह चैट नाम:",
		modifyGroupName: "समूह नाम संशोधित करें",
		addMember: "सदस्य जोड़ें",
		noData: "कोई डेटा नहीं, कृपया जोड़ें",
		avatar: "अवतार",
		nickName: "उपनाम",
		groupOwner: "मालिक",
		groupNotes: "समूह नोट्स",
		operate: "संचालित करें",
		editorNotes: "नोट्स संपादित करें",
		removeMember: "सदस्य हटाएं",
		userDoesNotBelong: "वर्तमान उपयोगकर्ता इस समूह से संबंधित नहीं है!",
		enterTheCommentName: "सदस्य का टिप्पणी नाम दर्ज करें",
		hint: "संकेत",
		selectMembers: "सदस्य चुनें",
		pleaseEnterTheGroupChatName: "कृपया समूह चैट नाम दर्ज करें",
		groupNameHasNotChanged: "समूह नाम नहीं बदला है!",
		groupNameCannotBeEmpty: "समूह नाम खाली नहीं हो सकता!",
		confirmToRemoveMember: "क्या सदस्य हटाने की पुष्टि करें?",
	},
	groupList: {
		groupChat: "समूह चैट",
		createGroupChat: "समूह चैट बनाएं",
		groupName: "समूह नाम:",
	},
	selectMember: {
		selectMembers: "सदस्य चुनें",
		chosen: "चुना गया:",
		contactPerson: "संपर्क व्यक्ति",
		salesperson: "विक्रेता",
		groupChat: "का समूह चैट",
		atLeast: "समूह चैट के लिए कम से कम 3 सदस्य आवश्यक हैं",
	},
	chat: {
		realTimeServer: "रीयल-टाइम सर्वर कनेक्शन विफल, कनेक्ट हो रहा है...",
		enterSearchContent: "खोज सामग्री दर्ज करें",
		recentChat: "हाल की चैट",
		addressBook: "संपर्क",
		groupChat: "समूह चैट",
		chatRecord: "चैट रिकॉर्ड",
		selectLanguage: "भाषा चुनें",
		ctrlEnter: "संदेश भेजने के लिए Ctrl + Enter दबाएं",
		commandEnter: "संदेश भेजने के लिए Command + Enter दबाएं",
		enter: "संदेश भेजने के लिए Enter दबाएं",
		translateContent: "सामग्री अनुवाद करें",
		send: "भेजें",
		imageUploadFailed: "छवि अपलोड विफल, कृपया पुनः प्रयास करें",
		onlyWithdrawMessages: "आप केवल अपने स्वयं के संदेश वापस ले सकते हैं",
		fileError: "वीडियो फ़ाइल की जानकारी पढ़ने में असमर्थ!",
		loadFailed: "लोड विफल, पुनः प्रयास करने के लिए क्लिक करें",
		loading: "लोड हो रहा है...",
		fileErrorTip:
			"भेजने में विफल। फ़ाइल प्रारूप चित्र या MP4 को समर्थन करता है, फ़ाइल का आकार 300MB से अधिक नहीं होना चाहिए और फ़ाइल की अवधि 30 मिनट से अधिक नहीं होनी चाहिए",
		aFile: "फ़ाइल",
		errprTip: "फ़ाइल अपलोड विफल, पुनः भेजा नहीं जा सकता, कृपया अपलोड करने के लिए फ़ाइल को फिर से चुनें।",
	},
	messageJS: {
		voice: "[वॉइस]",
		picture: "[चित्र]",
	},
	storeIndexJS: {
		have: "है",
		unreadMessages: "अपठित संदेश",
		haveNewMessage: "आपके पास एक नया संदेश है",
	},
	apiJS: {
		loginHasExpired: "लॉगिन समाप्त हो गया है, क्या आप फिर से लॉगिन करना चाहते हैं?",
		hint: "संकेत",
		unknownMistake: "अज्ञात त्रुटि",
	},
	sessionLock: {
		idleTimeout: "लंबे समय तक निष्क्रिय रहने के कारण आपका सत्र लॉक हो गया है। कृपया फिर से लॉगिन करें।",
	},
	router: {
		login: "लॉगिन",
		customerCommunication: "ग्राहक संचार",
		setup: "सेटअप",
		myClient: "मेरा ग्राहक",
		customerBinding: "ग्राहक बाइंडिंग",
		productSettings: "उत्पाद सेटिंग्स",
		syncSettings: "सिंक सेटिंग्स",
		personalInformation: "व्यक्तिगत जानकारी",
		authorizationSettings: "अधिकारीकरण सेटिंग्स",
		messageSending: "संदेश भेजना",
		aiEmail: "AI EMAIL设置",
		openClawManagement: "डिजिटल कर्मचारी प्रबंधन",
		omelinkUserServiceMaintenance: "OMELINK उपयोगकर्ता सेवा रखरखाव",
	},
	dateJS: {
		today: "आज",
	},
	common: {
		cancel: "रद्द करें",
		confirm: "पुष्टि करें",
		sure: "निश्चित",
		delete: "हटाएं",
		options: "विकल्प",
		option: "विकल्प",
		history: "इतिहास",
		all: "सभी",
		setup: "सेटअप",
	},
	chatMessageOrderDetails: {
		supplier: "आपूर्तिकर्ता",
		orderBy: "द्वारा आदेश",
		billTo: "बिल करने के लिए",
		shipTo: "को भेजना",
		deliveryDate: "वितरण तिथि",
		comment: "टिप्पणी",
		ordered: "आदेश दिया",
		include: "शामिल करें",
		orderDetails: "आदेश विवरण",
	},
	generalization: {
		listTitle: "प्रचार सूची",
		searchPlaceholder: "खोजें",
		checkOut: "विवरण देखें",
		sendAgain: "फिर से भेजें",
		send: "तुरंत भेजें",
		detailTitle: "प्रचार विवरण",
		isSendMessage: "को संदेश भेजें",
	},
	messageSending: {
		title: "OMELINK में पंजीकृत नहीं हैं",
		customerName: "मेहमान का नाम",
		customerPhone: "मेहमान का फ़ोन",
		associatedRestaurantId: "संबद्ध रेस्तरां ID",
		restaurantName: "रेस्तरां का नाम",
		operate: "कार्य",
		historyRecord: "इतिहास रिकॉर्ड",
		sendMessage: "एसएमएस भेजें",
		cancel: "रद्द करें",
		confirm: "भेजना पुष्टि करें",
		restaurantId: "रेस्तरां ID",
		close: "बंद करें",
		orderId: "आदेश ID",
		snedText: "भेजा गया सामग्री",
		sendTime: "भेजने का समय",
		sendSuccess: "सफलतापूर्वक भेजा गया",
		isCheckedDocument: "क्या दस्तावेज़ देखें?",
		isDownLoad: "क्या OMELINK डाउनलोड करें?",
		sendDocument: "दस्तावेज़ भेजें",
		true: "हाँ",
		false: "नहीं",
		check: "देखें",
	},
	aiEmail: {
		account: "ईमेल खाता",
		accountDescription: "AI ऑर्डर ईमेल प्राप्त और संसाधित करने के लिए मेलबॉक्स कॉन्फ़िगर करें।",
		configureAccount: "ईमेल कॉन्फ़िगर करें",
		editAccount: "ईमेल संपादित करें",
		emailAddress: "ईमेल पता",
		emailPassword: "ईमेल पासवर्ड",
		passwordSetHint: "पासवर्ड पहले से सेट है। इसे अपरिवर्तित रखने के लिए खाली छोड़ें।",
		accountEnabled: "ईमेल प्रोसेसिंग सक्षम करें",
		enabled: "सक्षम",
		disabled: "अक्षम",
		syncError: "सिंक त्रुटि",
		latestSync: "अंतिम सिंक",
		noSyncTime: "उपलब्ध नहीं",
		accountEmpty: "कोई ईमेल खाता कॉन्फ़िगर नहीं है। शुरू करने के लिए ईमेल पता और पासवर्ड सहेजें।",
		emailDisabledNotice: "यह ईमेल खाता अक्षम है। ईमेल सिंक या प्रोसेस नहीं होंगे, लेकिन संपर्कों को अभी भी प्रबंधित किया जा सकता है।",
		contacts: "ईमेल संपर्क",
		contactsDescription: "AI केवल कॉन्फ़िगर किए गए संपर्कों के ऑर्डर ईमेल को संसाधित करेगा।",
		addContact: "संपर्क जोड़ें",
		editContact: "संपर्क संपादित करें",
		guestEmail: "ग्राहक ईमेल",
		processingMode: "प्रोसेसिंग मोड",
		automatic: "पूर्ण स्वचालित",
		semiAutomatic: "अर्ध-स्वचालित",
		automaticDescription: "AI ग्राहक को अंग्रेज़ी में जवाब देता है और जानकारी पूरी होने पर ऑर्डर देता है।",
		semiAutomaticDescription: "AI चुपचाप ऑर्डर के इरादे को पहचानता है और ग्राहक को जवाब दिए बिना ऑर्डर देता है।",
		associatedCustomers: "संबंधित Customers",
		updatedAt: "अद्यतन समय",
		actions: "कार्रवाई",
		edit: "संपादित करें",
		delete: "हटाएं",
		customerPlaceholder: "Customers चुनें",
		noCustomers: "वर्तमान सेल्सपर्सन के लिए कोई Customer उपलब्ध नहीं है।",
		loadingAccount: "ईमेल सेटिंग लोड हो रही है...",
		loadingContacts: "संपर्क लोड हो रहे हैं...",
		validatingConnection: "ईमेल कनेक्शन सत्यापित हो रहा है...",
		save: "सहेजें",
		accountSaveSuccess: "ईमेल सेटिंग सहेजी गई।",
		statusUpdateSuccess: "ईमेल स्थिति अपडेट की गई।",
		contactCreateSuccess: "संपर्क बनाया गया।",
		contactUpdateSuccess: "संपर्क अपडेट किया गया।",
		contactDeleteSuccess: "संपर्क हटाया गया।",
		validationEmail: "मान्य ईमेल पता दर्ज करें।",
		validationPassword: "पहली बार खाता सहेजते समय ईमेल पासवर्ड आवश्यक है।",
		validationMode: "प्रोसेसिंग मोड चुनें।",
		validationCustomers: "कम से कम एक Customer चुनें।",
		confirmDelete: "हटाने की पुष्टि करें",
		deleteContactMessage: "हटाने के बाद, सिस्टम {email} से आने वाले नए ईमेल प्रोसेस नहीं करेगा। क्या इस संपर्क को हटाना है?",
	},
	serviceMaintenance: {
		userList: "उपयोगकर्ता सूची",
		serviceProviderList: "सेवा प्रदाता सूची",
		customerName: "ग्राहक का नाम",
		customerPhone: "ग्राहक फ़ोन",
		associatedRestaurantId: "संबद्ध रेस्तरां आईडी",
		restaurantName: "रेस्तरां का नाम",
		operate: "संचालित करें",
		serviceMaintenance: "सेवा प्रदाता रखरखाव",
		batchMaintenance: "थोक सेवा प्रदाता रखरखाव",
		sort: "क्रमांक",
		applicationName: "एप्लिकेशन का नाम",
		type: "श्रेणी",
		status: "स्थिति",
		selectUsers: "उपयोगकर्ता चुनें",
		selectServiceProvider: "सेवा प्रदाता चुनें",
		complete: "पूर्ण",
		nextStep: "अगला कदम",
		previous: "पिछला",
		selectServiceProviderTip: "उन सेवा प्रदाताओं का चयन करें जिन्हें प्रदर्शित करना है (चयनित नहीं किए गए सेवा प्रदाताओं को अवरुद्ध कर दिया जाएगा)",
		batchMaintenanceComplete: "थोक रखरखाव पूर्ण",
		latestShelvesTime: "नवीनतम शेल्फ समय",
		introduction: "व्यापार परिचय",
		businessName: "व्यापार का नाम",
		show: "प्रदर्शित करें",
		hide: "छिपाएं",
		soft: "सॉफ्टवेयर",
		service: "सेवा",
		successfulOperation: "सफल संचालन!",
	},
	openClawManagement: {
		guestName: "मेहमान का नाम",
		guestPhoneNumber: "मेहमान का फ़ोन",
		associatedRestaurantId: "संबद्ध रेस्तरां आईडी",
		restaurantName: "रेस्तरां का नाम",
		status: "डिजिटल कर्मचारी स्थिति",
		operate: "संचालित करें",
		show: "प्रदर्शित करें",
		hide: "छिपाएं",
		noData: "कोई डेटा नहीं",
		loading: "लोड हो रहा है...",
		updateSuccess: "सफल संचालन!",
	},
};
